/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimulationProductFields
 */
export interface SimulationProductFields {
    /**
     * 
     * @type {number}
     * @memberof SimulationProductFields
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationProductFields
     */
    productName?: string | null;
    /**
     * 
     * @type {{ [key: string]: string | null; }}
     * @memberof SimulationProductFields
     */
    fields?: { [key: string]: string | null; } | null;
}

/**
 * Check if a given object implements the SimulationProductFields interface.
 */
export function instanceOfSimulationProductFields(value: object): value is SimulationProductFields {
    return true;
}

export function SimulationProductFieldsFromJSON(json: any): SimulationProductFields {
    return SimulationProductFieldsFromJSONTyped(json, false);
}

export function SimulationProductFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationProductFields {
    if (json == null) {
        return json;
    }
    return {
        
        'productId': json['productId'] == null ? undefined : json['productId'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'fields': json['fields'] == null ? undefined : json['fields'],
    };
}

export function SimulationProductFieldsToJSON(json: any): SimulationProductFields {
    return SimulationProductFieldsToJSONTyped(json, false);
}

export function SimulationProductFieldsToJSONTyped(value?: SimulationProductFields | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productId': value['productId'],
        'productName': value['productName'],
        'fields': value['fields'],
    };
}

